import { useStore } from 'zustand';

import userStore from './modules/userStore';
import sessionStore from './modules/sessionStore';
import currentMallStore from './modules/currentMallStore';
import exampleStore from './modules/exampleStore';
import { gridPinStore } from './modules/gridPinStore';
import spaceUserStore from './modules/spaceUserStore';
import spaceUserV2Store from './modules/spaceUserV2Store';
import liveScheduleStore from './modules/liveScheduleStore';
import customerDetailStore from './modules/customerDetailStore';
import carouselStore from './modules/carouselStore';
import productEditorStore from './modules/productEditorStore';
import alimtalkCreditStore from './modules/alimtalkCreditStore';
import profileLinkLocaleStore from './modules/profileLinkLocaleStore';
import profileLinkEditorStore from './modules/profileLinkEditorStore';

export const useUserStore = () => useStore(userStore);
export const useProductEditorStore = () => useStore(productEditorStore);
export const useSessionStore = () => useStore(sessionStore);
export const useCurrentMallStore = () => useStore(currentMallStore);
export const useExampleStore = () => useStore(exampleStore);
export const useGridPinStore = () => useStore(gridPinStore);
export const useSpaceUserStore = () => useStore(spaceUserStore);
export const useSpaceUserV2Store = () => useStore(spaceUserV2Store);
export const useLiveScheduleStore = () => useStore(liveScheduleStore);
export const useCustomerDetailStore = () => useStore(customerDetailStore);
export const useCarouselStore = () => useStore(carouselStore);
export const useAlimtalkCreditStore = () => useStore(alimtalkCreditStore);
export const useProfileLinkLocaleStore = () => useStore(profileLinkLocaleStore);
export const useProfileLinkEditorStore = () => useStore(profileLinkEditorStore);

export const stores = {
    // non-component 모듈에서 사용
    userStore,
    sessionStore,
    exampleStore,
    spaceUserStore,
    liveScheduleStore,
    profileLinkLocaleStore,
    profileLinkEditorStore,
};

const useStoreHooks = {
    // component에서 사용하는 hooks
    useUserStore,
    useSessionStore,
    useCurrentMallStore,
    useExampleStore,
    useSpaceUserStore,
    useSpaceUserV2Store,
    useLiveScheduleStore,
    useCustomerDetailStore,
    useCarouselStore,
    useAlimtalkCreditStore,
    useProfileLinkLocaleStore,
    useProfileLinkEditorStore,
};

export default useStoreHooks;
